// extracted by mini-css-extract-plugin
export default {"body":"main_body__BG3-g","icon":"main_icon__g7rSC","bodyLink":"main_bodyLink__-y7bN","image":"main_image__kk5XU"};